import { Tabs } from 'antd';
import { useState } from 'react';
import { UserOutlined, BankOutlined } from '@ant-design/icons';
import LeadsFilter from './LeadsFilter'; // Import the LeadsFilter component
import CompanyFilter from './CompanyFilter'; // Import the CompanyFilter component

const { TabPane } = Tabs;

export default function Filter({ form, handleFilter, handleReset,setActiveTabMain }) {
  const [activeTab, setActiveTab] = useState('1');
  const [leadsFilterValues, setLeadsFilterValues] = useState({});
  const [companyFilterValues, setCompanyFilterValues] = useState({});

  const handleTabChange = (key) => {
    setActiveTab(key);
    setActiveTabMain(key);
    
  };

  const handleLeadsFilter = (values) => {
    if (activeTab === '1') {
      console.log(values);
      setLeadsFilterValues(values);
      const filteredValues = filterValuesByTabType(values, 'leads');
      console.log("Filtered Values:", filteredValues);
     
      handleFilter({ ...filteredValues, tabType: 'leads' });
      // Fetch leads data based on filtered values
      fetchLeadsData(filteredValues);
    }
  };

  const handleCompanyFilter = (values) => {
    if (activeTab === '2') {
      console.log("company filter");
      setCompanyFilterValues(values);
      const filteredValues = filterValuesByTabType(values, 'company');
      handleFilter({ ...filteredValues, tabType: 'company' });
      // Fetch company data based on filtered values
      fetchCompanyData(filteredValues);
    }
  };

  const filterValuesByTabType = (values, tabType) => {
    return Object.keys(values).reduce((acc, key) => {
      console.log("Key:", key);
      const [field, type] = key.split('_');
      if (type === tabType) {
        acc[field] = values[key];
      }
      return acc;
    }, {});
  };

  const fetchLeadsData = (filteredValues) => {
    // Fetch leads data based on filtered values
    // Example API call:
    // fetch('/api/leads', { method: 'POST', body: JSON.stringify(filteredValues) })
    //   .then(response => response.json())
    //   .then(data => setLeadsData(data));
  };

  const fetchCompanyData = (filteredValues) => {
    // Fetch company data based on filtered values
    // Example API call:
    // fetch('/api/companies', { method: 'POST', body: JSON.stringify(filteredValues) })
    //   .then(response => response.json())
    //   .then(data => setCompanyData(data));
  };

  return (
    <Tabs onChange={handleTabChange}>
      <TabPane  tab={<span><UserOutlined style={{paddingRight:10}} /> People</span>} key="1">
        <LeadsFilter
          form={form}
          handleFilter={handleLeadsFilter}
          handleReset={handleReset}
          initialValues={leadsFilterValues}
        />
      </TabPane>
      <TabPane style={{marginLeft:0}} tab={<span><BankOutlined style={{paddingRight:10}} /> Company</span>} key="2">
        <CompanyFilter
          form={form}
          handleFilter={handleCompanyFilter}
          handleReset={handleReset}
          initialValues={companyFilterValues}
        />
      </TabPane>
    </Tabs>
  );
}
